module.exports = __webpack_public_path__ + "img/hyundai.869ce703.jpg";